import forEach from 'lodash/forEach'
import { getQueryVariable } from 'tpm-utils'
import getProfile from 'tpm-lib/profile'

class AdController {
  get _cfg() {
    throw 'AdController not configured'
  }

  setCookie(name, val, days) {
    const d = new Date()
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + d.toUTCString()
    document.cookie = name + '=' + val + ';' + expires + ';path=/'
  }

  getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }

  setPageViewCookies() {
    const views = this.getCookie('adc_pv')
    const exp = this.getCookie('adc_exp')
    if (exp && views) {
      const incremented = views ? parseInt(views) + 1 : 1
      this.setCookie('adc_pv', incremented, 60) //any value larger than 30 will do
    } else {
      this.setCookie('adc_pv', 1, 60) //any value larger than 30 will do
      this.setCookie('adc_exp', 1, 30)
    }
  }

  setDailyViewCookies() {
    const dayExp = this.getCookie('adc_exp_day')
    if (dayExp) return null //within 1 day, just stop

    this.setCookie('adc_exp_day', 1, 1) //set the exp_day cookie

    const dailyViews = this.getCookie('adc_dv')
    const exp = this.getCookie('adc_exp')

    if (exp && dailyViews) {
      //set already & within 30 days
      const incremented = dailyViews ? parseInt(dailyViews) + 1 : 1
      this.setCookie('adc_dv', incremented, 60) //any value larger than 30 will do
    } else {
      // 30 days has expired or first visit
      this.setCookie('adc_dv', 1, 60) //any value larger than 30 will do
      this.setCookie('adc_exp', 1, 30)
    }
  }

  setCookies() {
    this.setPageViewCookies()
    this.setDailyViewCookies()
  }

  get pageViewsRange() {
    const pv = this.getCookie('adc_pv')
    if (pv >= 300) return '300'
    if (pv >= 200) return '200'
    if (pv >= 150) return '150'
    if (pv >= 90) return '90'
    if (pv >= 60) return '60'
    if (pv >= 30) return '30'
    if (pv >= 10) return '10'
    return '0'
  }

  get dailyVisitsRange() {
    const dv = this.getCookie('adc_dv')
    if (dv >= 30) return '30'
    if (dv >= 20) return '20'
    if (dv >= 10) return '10'
    if (dv >= 5) return '5'
    if (dv >= 1) return '1'
    return '0'
  }

  get htlbidLayout() {
    return 'universal'
    if (window.htlbid_layout) return window.htlbid_layout
    return null
  }

  get targeting() {
    const targeting = { ...this._cfg.targeting }
    const demoVal = getQueryVariable('demo')

    if (demoVal) targeting.demo = demoVal

    if (window.membership_was) targeting.membership_was = window.membership_was
    else targeting.membership_was = 'undefined'

    targeting.frequency = this.pageViewsRange
    targeting.frequency_days = this.dailyVisitsRange

    // HTLBID targeting
    // render test ads locally instead of real ads
    if (document.location.hostname === 'talkingpointsmemo.local') {
      targeting.is_testing = 'yes'
    }
    targeting.layout = this.htlbidLayout
    return targeting
  }

  noAds() {
    //no ads on pages with these paths
    if (
      window.location.pathname.indexOf('/prime') > -1 ||
      window.location.pathname.indexOf('/20th-anniversary') > -1 ||
      window.location.pathname.indexOf('/users') > -1 ||
      window.location.pathname.indexOf('/account') > -1 ||
      window.location.pathname.indexOf('/memberships') > -1 ||
      window.location.pathname.indexOf('/signin') > -1
    )
      return true

    return false
  }

  configure(cfg) {
    if (this.noAds()) return

    Object.defineProperty(this, '_cfg', {
      value: cfg,
    })
    window.htlbid.cmd.push(() => {
      forEach(this.targeting, (v, k) => {
        window.htlbid.setTargeting(k, v)
      })
    })
    if (!window.is_adfree)
      window.htlbid.cmd.push(() => {
        window.htlbid.layout(this.htlbidLayout)
      })
  }

  /* 
    look for a civicscience el and append the script
    doing it this way lets us serve the civicscience ad 
    to only non-members on the newspack fp
  */
  setupCivicScience() {
    const el = document.querySelector('#civsci-id-163878918')
    if (!!el) {
      const civicScienceScript = document.createElement('script')
      civicScienceScript.src =
        'https://www.civicscience.com/jspoll/4/civicscience-widget.js'
      el.parentElement.appendChild(civicScienceScript)
    }
  }
 
  constructor() {
    if (this.noAds()) return
    this.setCookies()
    const htlbid = window.htlbid || {}
    htlbid.cmd = htlbid.cmd || []
    window.htlbid = htlbid

    //no script for adfree
    if (window.is_adfree) return

    //otherwise keep going
    const htlScript = document.createElement('script')
    htlScript.async = true
    htlScript.src =
      window.tpm_VIP_GO_APP_ENVIRONMENT === 'production' 
        ? 'https://htlbid.com/v3/talkingpointsmemov2.com/htlbid.js'
        : 'https://htlbid.com/stage/v3/talkingpointsmemov2.com/htlbid.js'
    document.head.appendChild(htlScript)

    this.setupCivicScience()
  }
}

const instance = new AdController()
window.adc = instance

export default instance
export function __configure__(cfg) {
  /*
    need to get the membership_was value to set up targeting
    this seemed like the only sensible place to do it

    a better implementation would be a $doesspress->was_member() method
    and to write that to a global js var in the header like the other 
    membership vals. But jacob messed up and requested this instead 🙃 
  */
  getProfile().then((profile) => {
    //the targeting getter will read this

    if (tpm_profile.membership_was)
      window.membership_was = tpm_profile.membership_was

    instance.configure(cfg)
  })
}
